'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosBodyOutline = function IoIosBodyOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 3.8c-1.4 0-2.5 1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5z m0-1.3c2.1 0 3.8 1.6 3.8 3.8s-1.7 3.7-3.8 3.7-3.7-1.6-3.7-3.7 1.6-3.8 3.7-3.8z m13.1 8.8c1 0 1.9 0.8 1.9 1.8s-0.9 1.9-1.9 1.9h-7.8c-0.4 0-1.1 0.4-1.4 1.2-0.4 0.9-0.1 2.6 0.1 4l0.3 1.6v0.1l2.5 13.4c0.2 1-0.5 2-1.5 2.2h-0.4c-0.8 0-1.7-0.6-1.9-1.6l-1.6-9.3s-0.4-2.5-1.3-2.5h-0.2c-0.9 0-1.5 2.5-1.5 2.5l-1.6 9.3c-0.2 1-0.9 1.6-1.7 1.6h-0.4c-1-0.2-1.7-1.2-1.5-2.2l2.5-13.4v-0.1l0.3-1.6c0.2-1.4 0.5-3.1 0.1-4-0.3-0.8-0.9-1.2-1.4-1.2h-7.8c-1 0-1.9-0.9-1.9-1.9s0.9-1.8 1.9-1.8h26.2z m-26.2 2.5c-0.3 0-0.6-0.4-0.6-0.7s0.3-0.6 0.6-0.6h26.2c0.3 0 0.7 0.3 0.7 0.6s-0.4 0.7-0.7 0.7h-7.9c-1.3 0-2.1 1.1-2.4 1.8-0.4 1-0.5 2.5-0.1 4.8l0.3 1.5 0 0.2 2.5 13.4c0 0.3 0 0.4 0 0.5s-0.2 0.2-0.4 0.2h-0.2c-0.3 0-0.5-0.1-0.6-0.4l-1.6-9.4c0-0.2-0.2-0.8-0.4-1.5-0.2-0.4-0.4-0.8-0.7-1.2-0.5-0.7-1.1-0.8-1.5-0.8h-0.2c-0.4 0-1 0.1-1.5 0.8-0.3 0.4-0.5 0.8-0.7 1.2-0.3 0.7-0.4 1.3-0.4 1.4v0.1l-1.7 9.4c-0.1 0.3-0.2 0.5-0.5 0.5h-0.2c-0.2 0-0.3-0.2-0.4-0.3s-0.1-0.2 0-0.5l2.5-13.4v-0.1l0.3-1.6c0.4-2.3 0.4-3.8 0-4.8-0.3-0.7-1.1-1.9-2.5-1.9z' })
        )
    );
};

exports.default = IoIosBodyOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-body-outline.js
// module id = 2565
// module chunks = 168707334958949